module.exports = __webpack_public_path__ + "img/instore.e2709d4c.png";